import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token-bockarev') || '',
    user: null,
    receipts: null,
    documents: null,
    rules: null,
    privacyPolicy: null,
    personalData: null,
    userAgreement: null
  },
  mutations: {
    saveUser(state, data) {
      state.user = data
    },
    saveToken(state, data) {
      state.token = data
    },
    setReceipts(state, data) {
      state.receipts = data
    },
    setDocuments(state, data){
      state.documents = data
    },
    setRules(state, data){
      state.rules = data
    },
    setPrivacyPolicy(state, data){
      state.privacyPolicy = data
    },
    setUserAgreement(state, data){
      state.userAgreement = data
    },
    setPersonalData(state, data){
      state.personalData = data
    },
  },
  actions: {
    feedback({commit}, payload) {
      axios.post('feedback', payload)
    },

    getReceipts({commit}){
      axios.get('codes', {
        headers: {
          'Accept': "application/json",
          'Content-Type': "application/json",
          'access-control-allow-origin': "*",
          'Authorization': "Bearer " + localStorage.getItem('token-bockarev')
        }
      }).then((response) => {
          commit('setReceipts', response.data.data)
      })
    },

    getDocuments({commit}){
      axios.get('documents', {
        headers: {
          'Accept': "application/json",
        }
      }).then((response) => {
          commit('setDocuments', response.data.data)
      })
    }
  },
  getters : {
    user: state => {
      return state.user
    },
    receipts: state => {
      return state.receipts
    },
    documents: state => {
      return state.documents
    },
    rules: state => {
      return state.rules
    },
    userAgreement: state => {
      return state.userAgreement
    },
    personalData: state => {
      return state.personalData
    },
    privacyPolicy: state => {
      return state.privacyPolicy
    },
    token: token => {
      return token.documents
    },
  }
})
